import {
  Component, OnInit, TemplateRef, ViewChild, OnDestroy,
} from '@angular/core';
import { ConfirmDialogService } from './confirm-dialog.service';
import { ConfirmDialogActionEnum, ConfirmDialogBodyMessage } from './confirm-dialog.model';
import { Subscription } from 'rxjs';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as _ from 'lodash';

@Component({
  selector: 'ngx-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
})
export class NgxConfirmDialogComponent implements OnInit, OnDestroy {
  @ViewChild('confirmDialogModal') confirmDialogModal: TemplateRef<any>;

  headerTitle: string;
  bodyMessage: string[] | string | ConfirmDialogBodyMessage | ConfirmDialogBodyMessage[];
  yesButtonValue: string;
  noButtonValue: string;
  sizeDialog: 'sm' | 'lg';
  extraCancelButton: boolean;
  submitted: boolean;

  acceptAction: () => void;
  cancelAction: () => void;

  modalOpenRef: NgbModalRef;

  confirmDialogObservableSubscription: Subscription;

  constructor(
    private modalService: NgbModal,
    private confirmDialogService: ConfirmDialogService,
  ) {
  }

  ngOnInit(): void {
    this.submitted = false;

    this.confirmDialogObservableSubscription = this.confirmDialogService.confirmDialogObservable.subscribe(config => {
      if (config.action === ConfirmDialogActionEnum.SHOW) {
        this.hideConfirmDialogWithoutCallback();
        config.initialState = config.initialState || {};
        this.headerTitle = config.initialState.headerTitle || 'Warning!';
        this.bodyMessage = config.initialState.bodyMessage || 'Are you sure?';
        this.yesButtonValue = config.initialState.yesButtonValue || 'Yes';
        this.noButtonValue = config.initialState.noButtonValue || 'No';
        this.sizeDialog = config.initialState.sizeDialog || 'sm';
        this.extraCancelButton = config.initialState.extraCancelButton || false;
        this.acceptAction = config.accept;
        this.cancelAction = config.cancel;
        this.modalOpenRef = this.modalService.open(this.confirmDialogModal, {
          size: this.sizeDialog,
          backdrop: 'static',
          keyboard: false,
          centered: true,
        });
      } else if (config.action === ConfirmDialogActionEnum.HIDE) {
        this.hideConfirmDialogWithoutCallback();
        this.submitted = false;
      } else if (config.action === ConfirmDialogActionEnum.STOP_SUBMITTED) {
        this.submitted = false;
      }
    });
  }

  isMultipleBodyMessage() {
    return this.bodyMessage && _.isArray(this.bodyMessage);
  }

  isBodyMessageObject(singleBodyMessage: string | ConfirmDialogBodyMessage) {
    return singleBodyMessage && _.isObject(singleBodyMessage) && !_.isEmpty(singleBodyMessage);
  }

  hideConfirmDialogWithoutCallback(): void {
    if (this.modalOpenRef) {
      this.modalOpenRef.close();
      this.modalOpenRef = undefined;
    }
  }

  hideConfirmDialog(): void {
    this.hideConfirmDialogWithoutCallback();
    this.cancelAction && this.cancelAction();
  }

  executeAction(): void {
    this.submitted = true;
    this.acceptAction && this.acceptAction();
  }

  ngOnDestroy(): void {
    this.confirmDialogObservableSubscription.unsubscribe();
  }
}
